import Idb from "ui/helpers/Idb";

const DB_NAME = 'floor796';
export const STORE_FILES = 'files';
export const STORE_CONFIG = 'config';

let commonInstance = null;

export default class MainDb extends Idb {
	constructor() {
		if (commonInstance !== null) {
			throw new Error('Cannot create second instance of the Main DB');
		}

		super({
			name: DB_NAME,
			version: 1,
			stores: [
				{
					name: STORE_FILES,
					keyPath: 'id'
				},
				{
					name: STORE_CONFIG
				}
			]
		});

		commonInstance = this;
	}

	static getInstance() {
		if (commonInstance) {
			return commonInstance;
		}

		commonInstance = new MainDb();
		return commonInstance;
	}
}
